import { render, staticRenderFns } from "./country-redirect.vue?vue&type=template&id=12f79bca&scoped=true"
import script from "./country-redirect.vue?vue&type=script&lang=js"
export * from "./country-redirect.vue?vue&type=script&lang=js"
import style0 from "./country-redirect.vue?vue&type=style&index=0&id=12f79bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f79bca",
  null
  
)

export default component.exports